import React from 'react';
import { useLaunchCountdown } from '../hooks/useLaunchCountdown';
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-[56px] flex-col items-center min-[380px]:w-[68px] sm:w-[86px]" data-id="element-11" data-mp="1y33fi0uwdcaw">
      <span className="font-display text-[40px] leading-none tabular-nums text-cocoa min-[380px]:text-5xl sm:text-6xl" data-id="element-12" data-mp="1t9s89ym6atig">
        {value}
      </span>
      <span className="mt-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-cocoa-dim sm:text-xs" data-id="element-13" data-mp="1kbg8p73bwldv">
        {label}
      </span>
    </div>;
}

/** The only component that re-renders every second. */
export function CountdownTimer() {
  const {
    hours,
    minutes,
    seconds
  } = useLaunchCountdown();
  return <div className="flex min-h-[96px] items-center justify-center gap-0.5 rounded-2xl bg-cream-card px-3 py-4 min-[380px]:gap-1 min-[380px]:px-4 sm:min-h-[120px] sm:gap-2 sm:px-7" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-14" data-mp="15epjfqndcq1z">
      <Unit value={hours} label="HS" data-id="element-15" data-mp="1bz3tamzytuqr" />
      <span className="-mt-4 font-display text-3xl text-cocoa/25" aria-hidden="true" data-id="element-16" data-mp="1gzru20dzxpy6">
        :
      </span>
      <Unit value={minutes} label="MIN" data-id="element-17" data-mp="122r0drc8vkx2" />
      <span className="-mt-4 font-display text-3xl text-cocoa/25" aria-hidden="true" data-id="element-18" data-mp="123sniu6jbxv5">
        :
      </span>
      <Unit value={seconds} label="SEG" data-id="element-19" data-mp="1723xd4wty8dd" />
    </div>;
}